import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';

const SvgMenuOutlined = ({ size, title = 'MenuOutlined', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M7 6h13H7zm-2 6h15H5zm3 6h12H8z"
            />
        </g>
    </svg>
);

export default withIcon(SvgMenuOutlined);
